<template>
    <Modal @shown="shown" @hidden="hidden" ref="modal" @submit="submit">
        <template #title>
            {{ i18n('Add Profile') }}
        </template>
        <div class="alert alert-danger mb-2" v-if="errorMessage">{{ errorMessage }}</div>

        <div class="row" v-if="!application">
            <div class="col mb-2">
                <Field :disabled="submitted" type="dictionary" rest="applications?not_only_show_for_employee=1"
                    :required="true" :customAutofocus="true" :label="i18n('Application')" v-model="formData.application"
                    :errorMessage="errorMessages.application_id"
                    :sort="(a, b) => { return a.name.localeCompare(b.name); }" format="object" />
            </div>
        </div>

        <div class="row" v-if="!user">
            <div class="col mb-2">
                <Field :disabled="submitted" type="dictionary" :rest="`users${can('RESPONSIBLE_USER_MANAGE') ? '?responsibleExternalUser=' + $root.loggedUser.id : ''}`" :required="true" :customAutofocus="true"
                    :label="i18n('User')" v-model="formData.user_id" :errorMessage="errorMessages.user_id"
                    :sort="(a, b) => { return a.name.localeCompare(b.name); }" />
            </div>
        </div>

        <div class="row"
            v-if="formData.application?.is_by_user_profile_replication && $root?.features?.applications?.userProfileReplication?.enabled">
            <div class="col mb-2">
                <Field :disabled="submitted" type="dictionary" :rest="`applications/${formData.application.id}/users?minimal=1`"
                    :required="true" :customAutofocus="true" :label="i18n('Origin user')"
                    v-model="formData.user_origin_id" :errorMessage="errorMessages.user_origin_id"
                    :sort="(a, b) => { return a.name.localeCompare(b.name); }" />
            </div>
        </div>

        <template #footer>
            <div class="row">
                <div class="col text-end">
                    <button type="submit" class="btn btn-dark btn-sm" :disabled="submitted">
                        {{ i18n(formData.user_origin_id ? 'Save' : 'Continue') }}
                    </button>
                </div>
            </div>
        </template>
    </Modal>
</template>
<script>

import api from "@/api.js";
import Modal from "@/components/common/layout/Modal.vue";
import Field from "@/components/common/form/Field.vue";
import { translatedErrorMessage, } from "@/tools/errorHandling.js";

export default {
    components: {
        Modal,
        Field,
    },
    data() {
        return {
            submitted: false,
            formData: {},
            errorMessages: {},
            errorMessage: '',
        };
    },
    props: {
        user: {
            type: Object,
            default: null,
        },
        application: {
            type: Object,
            default: null,
        },
    },
    emits: [
        'shown',
        'hidden',
        'submit',
        'created',
        'updated',
        'setUserProfiles',
    ],
    mounted() {
        this.setFormData();
    },
    methods: {
        setFormData() {
            let formData = {};
            this.formData = formData;
        },
        show() {
            this.submitted = false;
            this.setFormData();
            this.errorMessage = '';

            if (this.application) {
                this.formData.application = this.application;
            } else {
                this.formData.application = null;
            }

            if (this.user) {
                this.formData.user_id = this.user.id;
            } else {
                this.formData.user_id = null;
            }

            this.$refs['modal'].show();
        },
        hide() {
            this.$refs['modal'].hide();
        },
        shown() {
            this.$emit('shown');
        },
        hidden() {
            this.$emit('hidden');
        },
        submit() {
            this.submitted = true;
            let promises = [];

            if (this.formData.user_origin_id) {
                api.get('applications/' + this.formData.application.id + '/profiles', {})
                    .then(applicationProfiles => {
                        api.get(`users/${this.formData.user_origin_id}/profiles`, {})
                            .then((userOriginProfiles) => {
                                userOriginProfiles = userOriginProfiles.filter(profile =>
                                    profile.application.id === this.formData.application.id
                                    && applicationProfiles.some(appProfile => appProfile.id === profile.id)
                                );

                                const addPromises = userOriginProfiles.map((profile) => {
                                    return api.post(`users/${this.formData.user_id}/profiles/${profile.id}`, {
                                        expires_at: profile.is_expiring ? this.expires_at : null,
                                        origin_external_user_id: this.formData.user_origin_id,
                                    });
                                });

                                Promise.all(addPromises)
                                    .then(() => {
                                        this.$emit('updated');
                                        this.hide();
                                    })
                                    .catch((error) => {
                                        console.log('error: ', error);
                                        this.errorMessage = translatedErrorMessage(error);
                                    });
                            })
                            .catch((error) => {
                                this.errorMessage = translatedErrorMessage(error);
                            });
                    });
            } else {
                promises.push(api.get('applications/' + this.formData.application.id, {}));
                promises.push(api.get('users/' + this.formData.user_id, {}));
                Promise.all(promises).then(([application, user]) => {
                    this.$emit('setUserProfiles', { user: user, application: application });
                    this.hide();
                }).catch(error => {
                    this.errorMessage = error.message;
                    this.submitted = false;
                });
            }
        },
    }
};
</script>